/**
 * Button colours for the Goal Game control page ONLY.
 *
 * Deliberately NOT a shared UI component: this must not change a single button
 * on any other page. It is a local class map using the app's own tokens, so it
 * reads correctly in light and dark mode.
 */
const base = 'inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-semibold transition-colors disabled:opacity-60';

export const btn = {
    // Save and anything that commits a change
    primary: `${base} bg-blue-600 hover:bg-blue-700 text-white shadow-sm`,
    // Navigate, copy, add, open a picker
    secondary: `${base} border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800`,
    // Regenerate, reset, clear — reversible but disruptive
    warning: `${base} border border-amber-400 text-amber-700 dark:text-amber-300 hover:bg-amber-50 dark:hover:bg-amber-500/10`,
    // Delete — not reversible
    danger: `${base} bg-rose-600 hover:bg-rose-700 text-white shadow-sm`,
    // Small inline variants
    smallPrimary: 'inline-flex items-center gap-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 text-xs font-semibold transition-colors disabled:opacity-60',
    smallSecondary: 'inline-flex items-center gap-1.5 rounded-lg border border-slate-300 dark:border-slate-600 px-3 py-1.5 text-xs font-semibold hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors disabled:opacity-60',
    iconDanger: 'p-2 rounded-lg border border-rose-300 text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-500/10 transition-colors disabled:opacity-60',
};

export default btn;
